import { render, staticRenderFns } from "./ReportOtherClients.vue?vue&type=template&id=64337548&"
import script from "./ReportOtherClients.vue?vue&type=script&lang=js&"
export * from "./ReportOtherClients.vue?vue&type=script&lang=js&"
import style0 from "./ReportOtherClients.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports